// Lista completa prefissi telefonici internazionali
export const PHONE_PREFIXES = [
  { code: '+39', flag: '🇮🇹', name: 'Italia' },
  { code: '+1', flag: '🇺🇸', name: 'USA / Canada' },
  { code: '+44', flag: '🇬🇧', name: 'Regno Unito' },
  { code: '+33', flag: '🇫🇷', name: 'Francia' },
  { code: '+49', flag: '🇩🇪', name: 'Germania' },
  { code: '+34', flag: '🇪🇸', name: 'Spagna' },
  { code: '+351', flag: '🇵🇹', name: 'Portogallo' },
  { code: '+31', flag: '🇳🇱', name: 'Paesi Bassi' },
  { code: '+32', flag: '🇧🇪', name: 'Belgio' },
  { code: '+41', flag: '🇨🇭', name: 'Svizzera' },
  { code: '+43', flag: '🇦🇹', name: 'Austria' },
  { code: '+45', flag: '🇩🇰', name: 'Danimarca' },
  { code: '+46', flag: '🇸🇪', name: 'Svezia' },
  { code: '+47', flag: '🇳🇴', name: 'Norvegia' },
  { code: '+358', flag: '🇫🇮', name: 'Finlandia' },
  { code: '+48', flag: '🇵🇱', name: 'Polonia' },
  { code: '+420', flag: '🇨🇿', name: 'Repubblica Ceca' },
  { code: '+36', flag: '🇭🇺', name: 'Ungheria' },
  { code: '+40', flag: '🇷🇴', name: 'Romania' },
  { code: '+30', flag: '🇬🇷', name: 'Grecia' },
  { code: '+421', flag: '🇸🇰', name: 'Slovacchia' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia' },
  { code: '+385', flag: '🇭🇷', name: 'Croazia' },
  { code: '+381', flag: '🇷🇸', name: 'Serbia' },
  { code: '+387', flag: '🇧🇦', name: 'Bosnia' },
  { code: '+355', flag: '🇦🇱', name: 'Albania' },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaria' },
  { code: '+380', flag: '🇺🇦', name: 'Ucraina' },
  { code: '+7', flag: '🇷🇺', name: 'Russia' },
  { code: '+90', flag: '🇹🇷', name: 'Turchia' },
  { code: '+972', flag: '🇮🇱', name: 'Israele' },
  { code: '+971', flag: '🇦🇪', name: 'Emirati Arabi' },
  { code: '+966', flag: '🇸🇦', name: 'Arabia Saudita' },
  { code: '+974', flag: '🇶🇦', name: 'Qatar' },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait' },
  { code: '+91', flag: '🇮🇳', name: 'India' },
  { code: '+86', flag: '🇨🇳', name: 'Cina' },
  { code: '+81', flag: '🇯🇵', name: 'Giappone' },
  { code: '+82', flag: '🇰🇷', name: 'Corea del Sud' },
  { code: '+65', flag: '🇸🇬', name: 'Singapore' },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia' },
  { code: '+66', flag: '🇹🇭', name: 'Thailandia' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam' },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia' },
  { code: '+63', flag: '🇵🇭', name: 'Filippine' },
  { code: '+61', flag: '🇦🇺', name: 'Australia' },
  { code: '+64', flag: '🇳🇿', name: 'Nuova Zelanda' },
  { code: '+55', flag: '🇧🇷', name: 'Brasile' },
  { code: '+54', flag: '🇦🇷', name: 'Argentina' },
  { code: '+52', flag: '🇲🇽', name: 'Messico' },
  { code: '+56', flag: '🇨🇱', name: 'Cile' },
  { code: '+57', flag: '🇨🇴', name: 'Colombia' },
  { code: '+51', flag: '🇵🇪', name: 'Perù' },
  { code: '+27', flag: '🇿🇦', name: 'Sudafrica' },
  { code: '+20', flag: '🇪🇬', name: 'Egitto' },
  { code: '+212', flag: '🇲🇦', name: 'Marocco' },
  { code: '+213', flag: '🇩🇿', name: 'Algeria' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya' },
];

export const DURATION_OPTIONS = [
  { value: '1h',  label_key: 'dur1h' },
  { value: '2h',  label_key: 'dur2h' },
  { value: '4h',  label_key: 'dur4h' },
  { value: 'day', label_key: 'durDay' },
];

export const DURATION_MINUTES = {
  '1h': 60, '2h': 120, '4h': 240, 'day': 480
};

export const SUPPORTED_LANGS = ['it', 'en', 'fr', 'de', 'es'];
